<template>
  <div>
    <img src="../assets/images/top-wave.png" class="wave" alt="wave">
    <div class="container-fluid" style="height: 100vh;">
      <div class="d-flex flex-column justify-content-between h-100">
        <!-- Formulario centrado -->
        <div class="d-flex justify-content-center align-items-center flex-grow-1">
          <div class="col-4">
            <div class="card-bill bg-white border border-gray border-radius">
            <div class="padding-bill">
              <div class="d-flex justify-content-center align-items-center pt-4">
                <img
                  class="logo-clinic"
                  src="../../../assets/Fabico_Clinic.png"
                  alt=""
                >
              </div>
              <form @submit.prevent="login">
                <h1 class="title-neon80 text-cyan-light text-center">Inicio de Sesión</h1>
                <div class="inputBox mt-4">
                  <input
                    type="email"
                    name="email"
                    required
                    v-model="email"
                    value=""
                    onkeyup="this.setAttribute('value', this.value);"
                    class="pb-1 h5"
                    autocomplete="off"
                  >
                  <label>Correo Electronico</label>
                </div>
                <div class="inputBox mt-4">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    required
                    v-model="password"
                    value=""
                    onkeyup="this.setAttribute('value', this.value);"
                    class="pb-1 h5 pr-4"
                    autocomplete="off"
                  >
                  <label>Contraseña</label>
                  <span class="toggle-password" @click="showPassword = !showPassword">
                    <!-- Ojo (mostrar) -->
                    <svg
                      v-if="!showPassword"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133
                        13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168
                        5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83
                        1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12
                        0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5
                        3.5 0 0 1-7 0z"/>
                    </svg>
                    <!-- Ojo tachado (ocultar) -->
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0
                        0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168
                        2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83
                        1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1
                        2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5
                        2.5 0 0 0 2.829 2.829z"/>
                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172
                        8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8
                        12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0
                        8 0 8s.939-1.721 2.641-3.238l.708.709z"/>
                      <path d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z"/>
                    </svg>
                  </span>
                </div>
                <b-alert
                  v-model="showAlert"
                  class="pr-0"
                  variant="danger"
                  dismissible
                >
                  {{validationError}}
                </b-alert>
                <div class="row mt-3 mb-3">
                  <div class="col-md-3"></div>
                  <button
                    type="submit"
                    class="col-md-5 btn btn-gradient text-white"
                  >
                    Entrar
                  </button>
                </div>
              </form>
            </div>
          </div>
          </div>
        </div>

        <!-- Texto CLÍNICA al final -->
        <div class="row" style="justify-content: flex-end;">
          <span class="text-dark h4 on-wave highlight-neon">Clínic</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'index',
  data() {
    return {
      email: null,
      password: null,
      showPassword: false,
      showAlert: false,
      validationError: null,
    };
  },
  methods:
  {
    async login() {
      const credenciales = { email: this.email, password: this.password };
      try {
        const response = await axios.post(`${process.env.VUE_APP_BASE_API}/v2/login`, credenciales);
        if (response.status === 200) {
          // eslint-disable-next-line camelcase
          const { access_token } = response.data.data;
          localStorage.setItem('user-token', access_token);
          window.location.href = 'dashboard';
        } else {
          console.log('estado: ', response.status);
        }
      } catch (error) {
        localStorage.removeItem('user-token');
        this.showAlert = true;
        this.validationError = error.response.data.message;
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: 'Neon 80s';
  src: url('~@/assets/fonts/Neon.ttf') format('truetype');
}

/* Tarjeta (medidas del ejemplo) */
.col-4 {
  flex: 0 0 400px !important;
  width: 400px !important;
  max-width: 400px !important;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}
.card-bill,
.card-bill * {
  box-sizing: border-box;
}
.bg-white {
  background: #fff;
}
.border-radius {
  border-radius: 15px;
}
.border-gray {
  border-color: #959595 !important;
}
.padding-bill {
  padding: 30px 50px;
  box-sizing: border-box;
}
.logo-clinic {
  display: block;
  margin: 0 auto;
  width: 45px !important;
  height: 45px !important;
  object-fit: contain;
}

/* Inputs (estilo original) */
.inputBox {
  position: relative;
}
.inputBox input {
  width: 100%;
  padding: 0.625rem 0;
  font-size: 1rem;
  color: #50b6ba;
  -webkit-text-fill-color: #50b6ba;
  letter-spacing: 0.062rem;
  margin-bottom: 1.875rem;
  border: none;
  border-bottom: 2px solid #52b4b7;
  outline: none;
  background: transparent;
}
/* Mantener el texto celeste también con el autocompletado del navegador */
.inputBox input:-webkit-autofill,
.inputBox input:-webkit-autofill:hover,
.inputBox input:-webkit-autofill:focus {
  -webkit-text-fill-color: #50b6ba;
  caret-color: #50b6ba;
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
  box-shadow: 0 0 0 1000px #fff inset;
  transition: background-color 9999s ease-in-out 0s;
}
.inputBox label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.625rem 0;
  font-size: 1rem;
  color: #50b6ba;
  pointer-events: none;
  transition: 0.5s;
}
.toggle-password {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1.25rem;
  color: #50b6ba;
  cursor: pointer;
}
.inputBox input:focus ~ label,
.inputBox input:valid ~ label,
.inputBox input:not([value='']) ~ label {
  top: -1.525rem;
  left: 0;
  color: #50b6ba;
  font-size: 0.75rem;
}
.title-neon80 {
  font-family: 'Neon 80s';
}
.btn-gradient {
  background-image: linear-gradient(to right, #7dd394 0%, #66d69e 51%, #54d8a7 100%);
  border-radius: 15px 15px;
}

/* Fondo */
.wave {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.on-wave {
  z-index: -1;
  right: 35px;
  font-size: 3rem;
  margin-top: 20px;
  font-family: 'Neon 80s';
}
.text-cyan-light {
  color: #50b6ba;
}
</style>
